const constants = { 
    "occupation" : [ 

        {
            "label": "Student ",
            "value": "Student"
          },
          {
            "label": "Not working",
            "value": "Not working"
          },
          {
            "label": "Housewife",
            "value": "Housewife"
          },
          {
            "label": "Agriculture/ Former",
            "value": "Agriculture/ Former"
          },
          {
            "label": "Govt employee",
            "value": "Govt employee"
          },
          {
            "label": "Bank employee ",
            "value": "Bank employee "
          },
          {
            "label": "Sales agent",
            "value": "Sales agent"
          },
          {
            "label": "Credit/ Insurance agent ",
            "value": "Credit/ Insurance agent "
          },
          {
            "label": "Merchant/ Shop owner",
            "value": "Merchant/ Shop owner"
          },
          {
            "label": "Youtuber/ Influencer",
            "value": "Youtuber/ Influencer"
          },
          {
            "label": "Finanacial adviser",
            "value": "Finanacial adviser"
          },
          {
            "label": "Stock trader",
            "value": "Stock trader"
          }
        ],
        qualifications: [
          "10th or below 10th",
          "12th Pass",
          "Diploma",
          "ITI",
          "Graduate",
          "Post Graduate",
          "CA"
          ],
          annualIncome: [
          "0 to 1,00,000",
          "1,00,000 to 2,50,000",
          "2,50,000 to 5,00,000",
          "5,00,000 to 10,00,000",
          "10,00,000 to 25,00,000",
          "more than 25,00,00"
          ]
    }

    export {constants}